(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["aroma-about-dialog"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('av-about-dialog')) {
  customElements.define('av-about-dialog', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.dialog = this.querySelector('dialog');
      this.trigger = this.querySelector('[data-av-about-open]');
      if (!this.dialog || !this.trigger || typeof this.dialog.showModal !== 'function') return;
      this.trigger.addEventListener('click', event => {
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button > 0) return;
        event.preventDefault();
        this.dialog.showModal();
        document.documentElement.classList.add('av-about-open');
      }, options);
      this.querySelector('[data-av-about-close]').addEventListener('click', () => this.dialog.close(), options);
      this.dialog.addEventListener('click', event => {
        if (event.target !== this.dialog) return;
        const bounds = this.dialog.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) this.dialog.close();
      }, options);
      this.dialog.addEventListener('close', () => {
        document.documentElement.classList.remove('av-about-open');
        if (this.trigger.isConnected) this.trigger.focus({ preventScroll: true });
      }, options);
    }
    disconnectedCallback() {
      if (this.dialog?.open) this.dialog.close();
      this.controller?.abort();
      document.documentElement.classList.remove('av-about-open');
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["aroma-brand-marquee"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('av-brand-marquee')) {
  customElements.define('av-brand-marquee', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.viewport = this.querySelector('[data-brand-viewport]');
      this.track = this.querySelector('[data-brand-track]');
      this.group = this.querySelector('[data-brand-group]');
      this.button = this.querySelector('[data-brand-toggle]');
      if (!this.group?.children.length) return;
      this.querySelector('[data-brand-copy]')?.remove();
      this.copy = this.group.cloneNode(true);
      this.copy.removeAttribute('data-brand-group');
      this.copy.setAttribute('data-brand-copy', '');
      this.copy.setAttribute('aria-hidden', 'true');
      this.copy.querySelectorAll('a').forEach(link => link.setAttribute('tabindex', '-1'));
      this.track.append(this.copy);
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = false;
      this.visible = true;
      this.hovered = false;
      this.focused = false;
      this.reducedMotion.addEventListener('change', () => this.measure(), options);
      this.button.addEventListener('click', () => { this.paused = !this.paused; this.updateButton(); this.schedule(); }, options);
      this.viewport.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse') { this.hovered = true; this.schedule(); } }, options);
      this.viewport.addEventListener('pointerleave', () => { this.hovered = false; this.schedule(); }, options);
      this.viewport.addEventListener('pointerdown', event => { if (event.pointerType !== 'mouse') { this.paused = true; this.updateButton(); this.schedule(); } }, options);
      this.viewport.addEventListener('focusin', () => { this.focused = true; this.schedule(); }, options);
      this.viewport.addEventListener('focusout', event => { if (!this.viewport.contains(event.relatedTarget)) { this.focused = false; this.schedule(); } }, options);
      document.addEventListener('visibilitychange', () => this.schedule(), options);
      this.resizeObserver?.disconnect();
      this.resizeObserver = new ResizeObserver(() => this.measure());
      this.resizeObserver.observe(this.viewport);
      this.resizeObserver.observe(this.group);
      this.visibilityObserver?.disconnect();
      this.visibilityObserver = new IntersectionObserver(entries => { this.visible = entries[0].isIntersecting; this.schedule(); });
      this.visibilityObserver.observe(this);
      this.measure();
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.resizeObserver?.disconnect();
      this.visibilityObserver?.disconnect();
      cancelAnimationFrame(this.frame);
    }
    measure() {
      this.distance = this.group.getBoundingClientRect().width;
      this.canMove = this.group.children.length > 1 && this.distance > this.viewport.clientWidth + 2;
      this.copy.hidden = !this.canMove || this.reducedMotion.matches;
      this.toggleAttribute('data-static', !this.canMove);
      this.button.hidden = !this.canMove || this.reducedMotion.matches;
      if (!this.canMove) this.viewport.scrollLeft = 0;
      this.updateButton();
      this.schedule();
    }
    updateButton() {
      this.button.setAttribute('aria-pressed', String(this.paused));
      this.button.setAttribute('aria-label', this.paused ? this.button.dataset.playLabel : this.button.dataset.pauseLabel);
    }
    schedule() {
      cancelAnimationFrame(this.frame);
      this.lastTime = 0;
      if (!this.canMove || this.paused || this.hovered || this.focused || !this.visible || document.hidden || this.reducedMotion.matches) return;
      this.position = this.viewport.scrollLeft;
      const tick = time => {
        if (!this.isConnected) return;
        if (this.lastTime) {
          this.position += Math.min(time - this.lastTime, 64) * (Number(this.dataset.speed) || 24) / 1000;
          if (this.position >= this.distance) this.position %= this.distance;
          this.viewport.scrollLeft = this.position;
        }
        this.lastTime = time;
        this.frame = requestAnimationFrame(tick);
      };
      this.frame = requestAnimationFrame(tick);
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["aroma-pdp-design"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('av-pdp-offer')) {
  customElements.define('av-pdp-offer', class extends HTMLElement {
    connectedCallback() {
      this.form = this.closest('form');
      if (!this.form) return;
      this.abort?.abort();
      this.abort = new AbortController();
      this.observer?.disconnect();
      this.observer = new MutationObserver(() => this.refresh());
      const options = this.form.querySelector('.js-product-options');
      if (options) this.observer.observe(options, { childList: true, subtree: true, characterData: true });
      this.querySelector('[data-av-copy]').addEventListener('click', async () => {
        const input = this.querySelector('input');
        const status = this.querySelector('[data-av-copy-status]');
        try {
          await navigator.clipboard.writeText(input.value);
          status.textContent = this.dataset.copied;
          const label = this.querySelector('[data-av-copy] span');
          const original = label.textContent;
          label.textContent = this.dataset.copied;
          clearTimeout(this.copyTimer);
          this.copyTimer = setTimeout(() => { label.textContent = original; }, 2200);
        } catch {
          input.focus(); input.select(); status.textContent = this.dataset.copyManual;
        }
      }, { signal: this.abort.signal });
      this.refresh();
    }
    refresh() {
      try { this.update(JSON.parse(this.form.querySelector('[data-selected-variant]')?.textContent || 'null')); } catch { this.update(null); }
    }
    update(variant) {
      this.querySelector('.av-offer-price').hidden = !variant?.available;
      if (variant) {
        const amount = Number(variant.price);
        const saving = Math.round(amount * .1);
        const money = cents => new Intl.NumberFormat(this.dataset.locale || 'bg', { style: 'currency', currency: this.dataset.currency || 'EUR' }).format(cents / 100);
        this.querySelector('[data-av-discount-price]').textContent = money(amount - saving);
        this.querySelector('[data-av-saving]').textContent = money(saving);
      }
      const single = this.form.querySelector('[data-av-volume-title]');
      if (single) { const match = single.dataset.avVolumeTitle.match(/(\d+(?:[.,]\d+)?)\s*(?:мл|ml)(?=[\s./]|$)/i); if (match && single.textContent !== `${match[1]} ML`) single.textContent = `${match[1]} ML`; }
      const rows = Array.from(this.form.querySelectorAll('[data-av-size]')).map(el => {
        const match = el.dataset.avSize.match(/^\s*(\d+(?:[.,]\d+)?)\s*(?:мл|ml)\.?\s*$/i);
        const volume = match ? Number(match[1].replace(',', '.')) : 0;
        const price = Number(el.dataset.avPrice);
        return { el, unit: volume > 0 && price > 0 ? price / volume : null, available: el.dataset.avAvailable === 'true' };
      });
      const available = rows.filter(row => row.available && row.unit !== null);
      const best = available.length > 1 ? Math.min(...available.map(row => row.unit)) : null;
      const allEqual = available.every(row => row.unit === best);
      rows.forEach(row => { const badge = row.el.querySelector('[data-av-best]'); if (badge) badge.hidden = !row.available || best === null || allEqual || row.unit !== best; });
    }
    disconnectedCallback() {
      this.abort?.abort(); clearTimeout(this.copyTimer);
      this.observer?.disconnect();
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["aroma-product-extras"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('av-product-extras')) {
  customElements.define('av-product-extras', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.key = 'aroma-viva-favorites-v1';
      this.feedback = this.querySelector('[data-feedback]');
      this.dialog = this.querySelector('dialog');
      this.refresh();
      this.querySelector('[data-favorite-toggle]').addEventListener('click', () => this.toggleFavorite(), options);
      this.querySelector('[data-favorites-open]').addEventListener('click', () => { this.renderFavorites(); this.dialog.showModal(); }, options);
      this.querySelector('[data-favorites-close]').addEventListener('click', () => this.dialog.close(), options);
      this.dialog.addEventListener('click', (event) => { if (event.target === this.dialog) { const r = this.dialog.getBoundingClientRect(); if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) this.dialog.close(); } }, options);
      this.querySelector('[data-favorites-list]').addEventListener('click', (event) => {
        const remove = event.target.closest('[data-remove-favorite]');
        if (remove && this.save(this.read().filter(item => item.id !== remove.dataset.removeFavorite))) this.renderFavorites();
      }, options);
      this.querySelector('[data-instagram-share]').addEventListener('click', () => this.shareInstagram(), options);
      window.addEventListener('storage', () => this.refresh(), options);
      window.addEventListener('av:favorites', () => this.refresh(), options);
      this.deliveryButton = this.closest('form')?.querySelector('.product-add-to-cart .add-to-cart');
      this.deliveryObserver?.disconnect();
      if (this.deliveryButton) {
        this.deliveryObserver = new MutationObserver(() => this.updateDelivery());
        this.deliveryObserver.observe(this.deliveryButton, { attributes: true, attributeFilter: ['disabled'] });
      }
      document.addEventListener('visibilitychange', () => { if (!document.hidden) this.scheduleDelivery(); }, options);
      this.scheduleDelivery();
    }
    disconnectedCallback() { this.abort?.abort(); this.deliveryObserver?.disconnect(); clearTimeout(this.deliveryTimer); }
    deliveryEstimate(now) {
      const parts = Object.fromEntries(new Intl.DateTimeFormat('en-GB', {
        timeZone: 'Europe/Sofia', year: 'numeric', month: '2-digit', day: '2-digit'
      }).formatToParts(now).map(part => [part.type, part.value]));
      const today = new Date(Date.UTC(Number(parts.year), Number(parts.month) - 1, Number(parts.day), 12));
      const addWorkingDays = count => {
        const date = new Date(today);
        while (count > 0) {
          date.setUTCDate(date.getUTCDate() + 1);
          if (date.getUTCDay() !== 0 && date.getUTCDay() !== 6) count -= 1;
        }
        return date;
      };
      return { today, start: addWorkingDays(5), end: addWorkingDays(7) };
    }
    deliveryDateLabel(date, withWeekday = false) {
      if ((this.dataset.deliveryLocale || 'bg').startsWith('bg')) {
        const months = ['яну', 'фев', 'мар', 'апр', 'май', 'юни', 'юли', 'авг', 'сеп', 'окт', 'ное', 'дек'];
        const weekdays = ['нд', 'пн', 'вт', 'ср', 'чт', 'пт', 'сб'];
        return `${withWeekday ? weekdays[date.getUTCDay()] + ', ' : ''}${date.getUTCDate()} ${months[date.getUTCMonth()]}`;
      }
      return new Intl.DateTimeFormat(this.dataset.deliveryLocale || 'en', {
        ...(withWeekday ? { weekday: 'short' } : {}), day: 'numeric', month: 'short', timeZone: 'UTC'
      }).format(date);
    }
    deliveryRangeLabel(start, end) {
      const sameYear = start.getUTCFullYear() === end.getUTCFullYear();
      const sameMonth = sameYear && start.getUTCMonth() === end.getUTCMonth();
      if ((this.dataset.deliveryLocale || 'bg').startsWith('bg')) {
        if (sameMonth) return `${start.getUTCDate()} – ${this.deliveryDateLabel(end)}`;
        if (sameYear) return `${this.deliveryDateLabel(start)} – ${this.deliveryDateLabel(end)}`;
        return `${this.deliveryDateLabel(start)} ${start.getUTCFullYear()} – ${this.deliveryDateLabel(end)} ${end.getUTCFullYear()}`;
      }
      const formatter = new Intl.DateTimeFormat(this.dataset.deliveryLocale || 'en', {
        day: 'numeric', month: 'short', ...(!sameYear ? { year: 'numeric' } : {}), timeZone: 'UTC'
      });
      return formatter.formatRange(start, end);
    }
    updateDelivery() {
      const estimate = this.deliveryEstimate(new Date());
      const orderDate = this.querySelector('[data-order-date]');
      if (orderDate) {
        orderDate.textContent = this.deliveryDateLabel(estimate.today, true);
        orderDate.dateTime = estimate.today.toISOString().slice(0, 10);
      }
      const dateElement = this.querySelector('[data-delivery-date]');
      if (!dateElement) return;
      const unavailable = !this.deliveryButton || this.deliveryButton.disabled;
      dateElement.classList.toggle('av-delivery-timeline__arrival--unavailable', unavailable);
      if (unavailable) {
        dateElement.textContent = this.dataset.deliveryFallback;
        dateElement.removeAttribute('aria-label');
        return;
      }
      const label = this.deliveryRangeLabel(estimate.start, estimate.end);
      dateElement.textContent = label;
      dateElement.setAttribute('aria-label', `${this.dataset.deliveryTitle} ${label}`);
    }
    scheduleDelivery() {
      clearTimeout(this.deliveryTimer);
      this.updateDelivery();
      this.deliveryTimer = setTimeout(() => this.scheduleDelivery(), 60000 - Date.now() % 60000 + 50);
    }
    read() {
      try {
        const data = JSON.parse(localStorage.getItem(this.key) || '[]');
        return Array.isArray(data) ? data.filter(item => item && typeof item.id === 'string' && typeof item.title === 'string' && typeof item.url === 'string' && new URL(item.url, location.origin).origin === location.origin).slice(0, 100) : [];
      } catch { return []; }
    }
    save(items) {
      try { localStorage.setItem(this.key, JSON.stringify(items)); window.dispatchEvent(new Event('av:favorites')); return true; }
      catch { this.feedback.textContent = this.dataset.storageError; return false; }
    }
    refresh() {
      const items = this.read();
      const saved = items.some(item => item.id === this.dataset.productId);
      this.querySelector('[data-favorite-toggle]').setAttribute('aria-pressed', String(saved));
      this.querySelector('[data-favorite-label]').textContent = saved ? this.dataset.savedLabel : this.dataset.addLabel;
      this.querySelector('[data-favorites-count]').textContent = String(items.length);
    }
    toggleFavorite() {
      const items = this.read();
      const saved = items.some(item => item.id === this.dataset.productId);
      const next = saved ? items.filter(item => item.id !== this.dataset.productId) : [{ id: this.dataset.productId, title: this.dataset.productTitle, url: this.dataset.productUrl, image: this.dataset.productImage }, ...items].slice(0, 100);
      if (this.save(next)) this.feedback.textContent = '';
    }
    renderFavorites() {
      const list = this.querySelector('[data-favorites-list]');
      list.replaceChildren();
      const items = this.read();
      if (!items.length) { const li = document.createElement('li'); li.textContent = this.dataset.emptyLabel; list.append(li); return; }
      items.forEach(item => {
        const li = document.createElement('li');
        const link = document.createElement('a'); link.href = item.url;
        if (item.image) {
          try { const url = new URL(item.image, location.origin); if (url.protocol === 'https:' && (url.hostname === location.hostname || url.hostname === 'cdn.shopify.com')) { const img = document.createElement('img'); img.src = url.href; img.alt = ''; img.width = 48; img.height = 64; img.loading = 'lazy'; link.append(img); } } catch {}
        }
        const title = document.createElement('span'); title.textContent = item.title; link.append(title);
        const remove = document.createElement('button'); remove.type = 'button'; remove.textContent = this.dataset.removeLabel; remove.dataset.removeFavorite = item.id; remove.setAttribute('aria-label', this.dataset.removeLabel + ': ' + item.title);
        li.append(link, remove); list.append(li);
      });
    }
    async shareInstagram() {
      const data = { title: this.dataset.productTitle, text: this.dataset.productTitle, url: this.dataset.productUrl };
      if (navigator.share) {
        try { await navigator.share(data); return; }
        catch (error) { if (error.name === 'AbortError') return; }
      }
      try { await navigator.clipboard.writeText(data.url); this.feedback.textContent = this.dataset.copiedLabel; }
      catch { const fallback = this.querySelector('[data-share-fallback]'); fallback.hidden = false; const input = fallback.querySelector('input'); input.focus(); input.select(); this.feedback.textContent = this.dataset.copyFallback; }
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
